// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GLB6","productName":"Table_productName__3-R2c"};